import { render } from "./Showerheads.vue?vue&type=template&id=0b8c633d&scoped=true"
import script from "./Showerheads.vue?vue&type=script&lang=js"
export * from "./Showerheads.vue?vue&type=script&lang=js"

import "./Showerheads.vue?vue&type=style&index=0&id=0b8c633d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8c633d"]])

export default __exports__